document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sub-compare-table').forEach(function (table) {
    const heads = Array.from(table.querySelectorAll('.sub-compare-group-head'));

    // Groups that render open on load never fire an expand transition, so give
    // their inner wrapper overflow:visible up front (tooltips on their first
    // row would otherwise be clipped).
    table.querySelectorAll('.sub-compare-group.is-open .sub-compare-group-inner')
      .forEach(function (inner) { inner.style.overflow = 'visible'; });

    // Toggling is-open animates the grid 0fr<->1fr collapse (CSS). We also
    // manage overflow on the inner wrapper so that:
    //  - while animating (and when collapsed) it clips, for a clean height
    //    transition, but
    //  - once fully open it goes overflow:visible, so tooltips on the first
    //    row can escape upward without being clipped.
    function setOpen(button, open) {
      const group = button.closest('.sub-compare-group');
      if (!group) return;
      const inner = group.querySelector('.sub-compare-group-inner');
      const body = group.querySelector('.sub-compare-group-body');

      group.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (!inner || !body) return;

      if (open) {
        // Reveal overflow only after the expand transition settles.
        const onEnd = function (e) {
          if (e.target !== body || e.propertyName !== 'grid-template-rows') return;
          body.removeEventListener('transitionend', onEnd);
          if (group.classList.contains('is-open')) inner.style.overflow = 'visible';
        };
        body.addEventListener('transitionend', onEnd);
      } else {
        // Clip again immediately so the collapse animation stays tidy.
        inner.style.overflow = '';
      }
    }

    heads.forEach(function (button, index) {
      // Native <button> already handles Enter/Space activation.
      button.addEventListener('click', function () {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        setOpen(button, !isOpen);
      });

      // Roving keyboard navigation between category headers.
      button.addEventListener('keydown', function (event) {
        let target = null;

        switch (event.key) {
          case 'ArrowDown':
            target = heads[Math.min(index + 1, heads.length - 1)];
            break;
          case 'ArrowUp':
            target = heads[Math.max(index - 1, 0)];
            break;
          case 'Home':
            target = heads[0];
            break;
          case 'End':
            target = heads[heads.length - 1];
            break;
          default:
            return;
        }

        if (target) {
          event.preventDefault();
          target.focus();
        }
      });
    });
  });
});
